import React from "react";
import PropTypes from "prop-types";
import { Field, reduxForm, initialize } from "redux-form";
export const fields = ["name", "company", "email", "telf"];

const validate = values => {
  const errors = {};

  if (!values.name) errors.name = "Campo Nome é obrigatório.";
  if (!values.company) errors.company = "Campo Entidade é obrigatório.";
  if (!values.email) {
    errors.email = "Campo Email é obrigatório.";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Endereço de email inválido.";
  }
  if (!values.telf) errors.telf = "Campo Telefone é obrigatório.";

  return errors;
};

const renderField = ({
  input,
  label,
  type,
  meta: { touched, error, warning }
}) => (
  <div>
    <label>{label}</label>
    <div>
      <input {...input} className="form-control" type={type} />
      {touched &&
        ((error && <span>{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  </div>
);

export class TicketForm extends React.Component {
  /*
  handleSubmit (e) {
    e.preventDefault()
    const { form } = this.props
    form.forceValidate()

    if (form.isValid()) {
      this.setState({message: 'Success!', error: undefined})
    } else {
      this.setState({error: 'Please correct the errors.', message: undefined})
    }
  }
  */

  render() {
    const {
      fields: { name, company, email, telf },
      handleSubmit,
      submitting
    } = this.props;

    return (
      <form key="contact" onSubmit={handleSubmit}>
        <div>
          <div>
            <Field
              component={renderField}
              name="name"
              label="Nome*"
              type="text"
            />
          </div>
        </div>
        <div>
          <Field
            component={renderField}
            name="company"
            label="Entidade*"
            type="text"
          />
        </div>
        <div>
          <Field
            component={renderField}
            name="email"
            label="Email*"
            type="text"
          />
        </div>
        <div>
          <Field
            component={renderField}
            name="telf"
            label="Telefone*"
            type="text"
          />
        </div>
        <div>
          <strong>* Campos de preenchimento obrigatório</strong>
          <button className="pull-right" type="submit" disabled={submitting}>
            {submitting ? <i /> : <i />} Enviar
          </button>
        </div>
      </form>
    );
  }
}

TicketForm.propTypes = {
  fields: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired
};

TicketForm = reduxForm({
  form: "contact", // the name of your form and the key to
  // where your form's state will be mounted
  fields: ["name", "company", "email", "telf"], // a list of all your fields in your form
  validate // a synchronous validation function
})(TicketForm);

export default TicketForm;



// WEBPACK FOOTER //
// ./src/views/AboutView/TicketForm.js